/// <reference path="../../../../node_modules/jqwidgets-scripts/jqwidgets-ts/jqwidgets.d.ts" />
/// <reference path="../../../../node_modules/@types/jqueryui/index.d.ts" />
import { Observable, ObservableArray, Computed, SubscribableFunctions, ObservableExtenderOptions } from "knockout";

import * as ko from "knockout";
import dataModel from "data-model";
import GridStateComponentViewModel from "../../shared-components/jqx.grid-state-component/jqx.grid-state-component";
import {GenerateGuid, noop} from "global-functions";
import { showconfirm } from "show-dialog-methods";
import router from "router";

const overrideTempFilterName = "SearchFilterData";

const fetchSearchFiltersAsync = (payload) => {
    return new Promise((resolve, reject) => {
        dataModel.ajaxRequest("UserProfile/GetUserSearchFilterList", "GET", payload)
        .done(resolve)     
        .fail((err) => reject((err.responseJSON && err.responseJSON.message) || `An error occurred during request.`))   
    })
}

const convertJsonStringToObj = (data = "") => {
    try {
        const x = JSON.parse(data);
        return x;
    }
    catch {
        return {}
    }
}

//{name: this.gridId, pageName: this.currentUrl}
export const loadSavedSearches = async (name, currentUrl?) => {
    try {
        currentUrl = currentUrl || window.location.pathname;
        const results = await fetchSearchFiltersAsync({name, pageName: currentUrl}) as Array<any>;
        
        return (results ?? []).map((x) => {
            const search = convertJsonStringToObj(x.search);

            if(Object.keys(search).length) {
                search.isDefault = x.isDefault ?? false
            }

            return {...x, search: JSON.stringify(search)};
        })
        
    }
    catch(err) {
        console.log(err)
        return []
    }
}

interface SearchListModelInterface {
    label?: string;
    value?: unknown;
}

class SearchListModel implements SearchListModelInterface {
    
    value;
    label;

    constructor(x) {
        
        this.value = x.value;
        this.label = x.label;
    }
}

export class SearchFilterSavesViewModel {
    prevSelected = new SearchListModel({});
    selectedName: string = "";
    _selectedSavedSearchId: Observable<SearchListModelInterface | undefined> = ko.observable();
    selectedSavedSearchId: ko.PureComputed<SearchListModelInterface | undefined> = ko.pureComputed({
        read: this._selectedSavedSearchId,
        write: (val) => {
            this._selectedSavedSearchId(val);
        }
    });
    savedSearches: Observable<any[]> = ko.observableArray([]);
    selectedSavedSearch: Observable<any> = ko.observable();

    currentUrl = window.location.pathname;
    clearFilter;
    refreshSearchList;
    handleOnSelected;
    gridId;
    $grid;
    dropdownListId = GenerateGuid(6);
    showNewTabPopup = false;
    
    constructor({gridId, onClearFilter, onRefreshSearchList, onSelected}) {
        this.gridId = gridId;
        this.$grid = $(`#${gridId}`);
        this.showNewTabPopup = false;

        this.clearFilter = onClearFilter || ko.observable(false);
        this.refreshSearchList = onRefreshSearchList || ko.observable("");
        this.handleOnSelected = onSelected;

        this.selectedSavedSearch.subscribe(async (data) => {
            if(data == null) {
                this.prevSelected = new SearchListModel({});
            }
            else if(data?.label !== this.selectedName) {
                await this.applyGridFilters(data.value, data.label, this.showNewTabPopup);
            }

            this.selectedName = data?.label ?? "";
            this.showNewTabPopup = true;
        });    
        
        const query = this.getLoadSearchOverride();
        this.getSearchFilters(query.gridId === gridId ? query.searchName : "");

        this.clearFilter.subscribe((yes) => yes && this.handleResetSelection())

        let resetRefreshSearchList = false
        this.refreshSearchList.subscribe(async (searchName?: string) => {
            if(resetRefreshSearchList) {
                resetRefreshSearchList = false;
                return;
            }

            if(searchName && searchName.length > 0) {
                resetRefreshSearchList = true;
                this.refreshSearchList("");
                await this.getSearchFilters(searchName);
            }
            else {
                await this.getSearchFilters();
            }
        })
    }

    getLoadSearchOverride = () => {
        try {
            const dataStr = window.sessionStorage.getItem(overrideTempFilterName);
    
            if(dataStr) {
                const data = JSON.parse(dataStr);
                window.sessionStorage.removeItem(overrideTempFilterName);

                return data;
            }
            
            return {};
        }
        catch(err) {
            console.error(err);
            return {};
        }
        
    }

    getURLSearchQuery = () => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const searchname = urlParams.get('searchName');
        const gridId = urlParams.get('gridId');
    
        return { searchname, gridId };
    }

    getSearchFilters = async (defaultSelectedName = "") => {
        const response = await loadSavedSearches(this.gridId, this.currentUrl);
        const defaultSearch = response.find(x => x.isDefault);
        this.showNewTabPopup = (defaultSelectedName == null || defaultSearch == null);

        const mapped = response.filter(x => x.searchName !== "").map(x => {
            const state = this.mapGridState(x.search);
            return new SearchListModel({ label: x.searchName, value: state })
        }) as Array<any>;

        this.savedSearches(mapped);
        
        let item;
        if(defaultSelectedName) {
            item = mapped.find(x => x.label === defaultSelectedName);
        }
        else if(defaultSearch) {
            item = mapped.find(x => x.label === defaultSearch.searchName);
        }

        if(item) {
            this.showNewTabPopup = false;
            this.selectedSavedSearchId(item);
        }
        else {
            await this.applyGridFilters("");
        }
    }

    handleResetSelection = () => {
        ($(`#${this.dropdownListId}`) as any).jqxDropDownList("clearSelection");
        this.selectedSavedSearchId(null);
        this.selectedSavedSearch(null);
        this.clearFilter(false);
    }

    applyGridFilters = async (stateStr = "", searchName = "", showNewTab = false) => {

        if(searchName && showNewTab && searchName !== this.selectedName) {
            const yes = await showconfirm(`Do you want to open the saved search in a new tab?`)

            if(yes) {
                const tab = window.open(window.location.href, "_blank");

                if(tab) {
                    tab.sessionStorage.setItem(overrideTempFilterName, JSON.stringify({searchName, gridId: this.gridId}));
                }

                if(this.prevSelected && this.prevSelected.label) {
                    const item = this.savedSearches().find(x => x.label === this.prevSelected.label);
                    if(item) {
                        this.selectedSavedSearchId(item);
                    }
                }
                else {
                    this.handleResetSelection();
                }
                
                return false;
            }
            
        }
        const searchData = convertJsonStringToObj(stateStr);

        if(searchData.userSearchName !== this.prevSelected.label) {
            this.prevSelected = new SearchListModel({label: searchData.userSearchName, value: stateStr});
        }

        if(this.handleOnSelected) {
            this.handleOnSelected(searchData);
        }
    }

    private mapGridState = (gridState: string) => {
        try {
            const state = JSON.parse(gridState);

            if(state?.grid?.filters && state?.grid?.filters.filterscount == null) {
                let count = 0;

                Object.keys(state?.grid?.filters).forEach((key) => {
                    if(key.indexOf("datafield") !== -1) {
                        count++;
                    }
                })

                state.grid.filters.filterscount = count;
            }

            return JSON.stringify(state);
        }
        catch(err) {
            return gridState;
        }
    }
}

import template from './SearchFilter-Saves-Component.html';
import { over } from "lodash";
export default { viewModel: SearchFilterSavesViewModel, template: template };
